import PropTypes from "prop-types";
import { Children, PureComponent } from "react";

import { Helmet } from "react-helmet";

import Column from "flavours/glitch/components/column";
import ColumnHeader from "flavours/glitch/components/column_header";

// Renders a page either as a regular column (with header) or, when `embedded`,
// as a bounded block that can sit inside a settings accordion.
export default class PageFrame extends PureComponent {

  static propTypes = {
    embedded: PropTypes.bool,
    children: PropTypes.node,
  };

  setRef = c => {
    this.column = c;
  };

  scrollTop () {
    this.column?.scrollTop();
  }

  render () {
    const { embedded, children, ...rest } = this.props;

    if (embedded) {
      const content = Children.toArray(children).filter(child => child?.type !== ColumnHeader && child?.type !== Helmet);

      return <div className='settings-embed'>{content}</div>;
    }

    return <Column ref={this.setRef} {...rest}>{children}</Column>;
  }

}
